var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Send-Email-1--Streamline-Ultimate",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M23.3 0.619995 9.23 17.6l-0.91 5.9c-0.16602 0.0014 -0.32836 -0.0488 -0.46454 -0.1438 -0.13618 -0.0949 -0.23944 -0.2299 -0.29546 -0.3862l-2.61 -7.2L23.3 0.619995Z",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M23.3 0.620003 4.95 15.77l-3.8 -1.63c-0.184935 -0.0809 -0.343699 -0.2117 -0.458502 -0.3777 -0.114804 -0.166 -0.181112 -0.3607 -0.191496 -0.5623 -0.009887 -0.2011 0.037485 -0.4009 0.136612 -0.5761 0.099127 -0.1752 0.245942 -0.3188 0.423386 -0.4139L22.71 0.560003c0.0932 -0.049692 0.1991 -0.070521 0.3041 -0.059836 0.1051 0.010685 0.2046 0.052401 0.2859 0.119836Z",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m23.48 1.18 -5.31 18.93c-0.0395 0.1481 -0.1111 0.2857 -0.2096 0.4032 -0.0984 0.1175 -0.2215 0.212 -0.3604 0.2768 -0.137 0.065 -0.2862 0.1004 -0.4379 0.1038 -0.1516 0.0035 -0.3022 -0.0251 -0.4421 -0.0838l-4.84 -2.08 -2.88999 4.41c-0.07405 0.1099 -0.17376 0.2001 -0.29049 0.2628 -0.11674 0.0628 -0.247 0.0961 -0.37951 0.0972l0.91 -5.9L23.3 0.619995c0.0831 0.06417 0.1449 0.152052 0.177 0.252038 0.0321 0.099985 0.0332 0.207367 0.003 0.307967Z",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.953 15.765 23.299 0.617004",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9.231 17.6 7.489 3.209c0.1404 0.0602 0.292 0.0895 0.4448 0.0861 0.1527 -0.0034 0.3029 -0.0394 0.4405 -0.1058 0.1375 -0.0663 0.2593 -0.1613 0.3571 -0.2787 0.0977 -0.1173 0.1692 -0.2543 0.2096 -0.4016L23.48 1.18c0.0285 -0.10115 0.0266 -0.208467 -0.0055 -0.308544 -0.0321 -0.100078 -0.0929 -0.188486 -0.175 -0.254192 -0.082 -0.065705 -0.1815 -0.105796 -0.2862 -0.115269 -0.1047 -0.009473 -0.2098 0.012092 -0.3023 0.062003L1.06299 12.208c-0.177287 0.0956 -0.324035 0.2392 -0.423392 0.4144 -0.099358 0.1752 -0.147299 0.3749 -0.138319 0.5761 0.00898 0.2012 0.074516 0.3958 0.189086 0.5615 0.11457 0.1656 0.273529 0.2956 0.458625 0.375l3.8 1.63",
    strokeWidth: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m4.953 15.765 2.6 7.2c0.05071 0.1408 0.13966 0.2647 0.25686 0.3577 0.11721 0.0931 0.25803 0.1516 0.40666 0.1691 0.14863 0.0174 0.29918 -0.0069 0.43475 -0.0703 0.13557 -0.0634 0.2508 -0.1633 0.33273 -0.2885l2.889 -4.4",
    strokeWidth: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M23.299 0.617004 9.231 17.599 8.315 23.5",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.e3d31e1802590a7a6f1f62f0fe40fc58.svg";
export { ForwardRef as ReactComponent };